import React from 'react'

const TimelineTab = ({ events, S }) => {
  const evs = events || [];
  const typeIcons = { status: 'shield', document: 'file-text', assignment: 'users', note: 'message-circle' };
  const typeColors = { status: '#3b82f6', document: '#10b981', assignment: '#8b5cf6', note: '#f59e0b' };
  const icons = {
    shield: (
      <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z' />
      </svg>
    ),
    'file-text': (
      <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
        <polyline points='14 2 14 8 20 8' />
        <line x1='16' y1='13' x2='8' y2='13' />
        <line x1='16' y1='17' x2='8' y2='17' />
      </svg>
    ),
    users: (
      <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2' />
        <circle cx='9' cy='7' r='4' />
        <path d='M23 21v-2a4 4 0 0 0-3-3.87' />
        <path d='M16 3.13a4 4 0 0 1 0 7.75' />
      </svg>
    ),
    'message-circle': (
      <svg width='14' height='14' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
        <path d='M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z' />
      </svg>
    ),
    clock: (
      <svg width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round'>
        <circle cx='12' cy='12' r='10' />
        <polyline points='12 6 12 12 16 14' />
      </svg>
    ),
  };
  return (
    <div style={{ position: 'relative', paddingLeft: 32 }}>
      <div style={{ position: 'absolute', left: 15, top: 0, bottom: 0, width: 2, background: S.borderLight }} />
      {evs.map(ev => {
        const color = typeColors[ev.type] || '#64748b';
        return (
          <div key={ev.id} style={{ position: 'relative', marginBottom: 28, paddingLeft: 20 }}>
            <div
              style={{
                position: 'absolute',
                left: -24,
                top: 2,
                width: 30,
                height: 30,
                borderRadius: 8,
                background: color + '15',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                border: `2px solid ${color}30`,
              }}
            >
              <span style={{ color }}>{icons[typeIcons[ev.type]] || icons.clock}</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'baseline', gap: 8, marginBottom: 4 }}>
              <span style={{ fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{ev.user}</span>
              <span style={{ fontSize: 13, color: S.textMuted }}>{ev.action}</span>
              {ev.detail && <span style={{ fontSize: 13, fontWeight: 600, color: S.textPrimary }}>{ev.detail}</span>}
            </div>
            <div style={{ fontSize: 12, color: S.textMuted, marginBottom: 6, display: 'flex', alignItems: 'center', gap: 4 }}>
              <span style={{ color: '#94a3b8' }}>{icons.clock}</span> {ev.time}
            </div>
            {ev.note && (
              <div
                style={{
                  fontSize: 13,
                  color: S.textSecondary,
                  lineHeight: 1.5,
                  background: S.bgCard,
                  border: `1px solid ${S.borderLight}`,
                  borderRadius: 10,
                  padding: '10px 14px',
                }}
              >
                {ev.note}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
}

export default TimelineTab